<template>
  <div class="home">
    <article v-if="loaded" v-html="content.content.rendered"></article>
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import { settings } from '../variables.js'
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  data () {
    return {
      content: {}
    }
  },
  created: function () {
    this.axios
      .get(settings.jsonUrl + 'gi/v1/frontpage')
      .then(response => (this.content = response.data))
      .then(function (result) {
        NProgress.done()
      })
      .catch(error => console.log(error))
  },
  computed: {
    loaded () {
      return !(Object.entries(this.content).length === 0 && this.content.constructor === Object)
    }
  }
}
</script>
